//clamp function
export const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

//inverse lerp function
export const inverseLerp = (a, b, v) => (v - a) / (b - a);

export function easeInCubic(x) {
  return x * x * x * x * x;
}

export function easeOutCubic(x) {
  return 1 - Math.pow(1 - x, 4);
}

export function arrayRotate(arr, count) {
  count -= arr.length * Math.floor(count / arr.length);

  arr.push.apply(arr, arr.splice(0, count));

  return arr;
}

const hexToHsl = (hex) => {
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h;
  let s;
  const l = (max + min) / 2;

  if (max === min) {
    h = s = 0; // achromatic
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }

  return [h, s, l];
};
const hslToHex = (h, s, l) => {
  let r;
  let g;
  let b;

  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    const hue2rgb = (p, q, t) => {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    };

    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);

    r = Math.round(r * 255);
    g = Math.round(g * 255);
    b = Math.round(b * 255);
  }

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};
export const correctColour = (colour, minimumBrightness, maximumSaturation) => {
  // convert hex to hsl
  const hsl = hexToHsl(colour);

  if (hsl[2] < minimumBrightness) {
    hsl[2] = minimumBrightness;
  }

  if (maximumSaturation && hsl[1] > maximumSaturation) {
    hsl[1] = maximumSaturation;
  }

  // convert hsl to hex
  return hslToHex(hsl[0], hsl[1], hsl[2]);
};
